var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chatItem"},[_c('div',{staticClass:"userInfo"},[_c('img',{attrs:{"src":_vm.chatItem.avatar || _vm.defaultAvatar,"alt":""}})]),_c('div',{staticClass:"chatWrap"},[_c('img',{style:({
        width: _vm.imageSize.width + 'px',
        height: _vm.imageSize.height + 'px'
      }),attrs:{"src":_vm.chatItem.chatContext},on:{"click":function($event){return _vm.handlePreview(_vm.chatItem.chatContext)},"load":_vm.handleImageLoad}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }